module.exports = __webpack_public_path__ + "static/media/delete.99e67119.svg";